<template>
  <button class="mdc-button" :class="classes" @click="onClick">
    <slot name="leading-icon"/>
      <slot/>
    <slot name="trailing-icon"/>
  </button>
</template>

<script>
import { MDCRipple } from '@material/ripple'

export default {
  name: 'mdc-button',
  props: {
    raised: {
      type: Boolean,
      default: false
    },
    unelevated: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    to: {
      type: String
    },
    href: {
      type: String
    }
  },
  computed: {
    classes () {
      return {
        'mdc-button--raised': this.raised,
        'mdc-button--unelevated': this.unelevated,
        'mdc-button--outlined': this.outlined,
        'mdc-button--dense': this.dense
      }
    }
  },
  mounted () {
    this.buttonRipple = MDCRipple.attachTo(this.$el)
  },
  methods: {
    onClick (event) {
      if (this.href) {
        location.href = this.href
      } else {
        this.$emit('click', event)
        if (this.to) {
          this.$router.push(this.to)
        }
      }
    }
  }
}
</script>

<style>
.mdc-button.mdc-button--dense {
  height:42px;
  margin-top:12px;
}
.mdc-button .mdc-button__icon, .mdc-button .mdc-icon {
  margin-left: 0;
  margin-right: 8px;
  display: inline-block;
  width: 18px;
  height: 18px;
  font-size: 18px;
  vertical-align: top;
}
.mdc-icon.mdc-icon--material {
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}
</style>
